export default __webpack_public_path__ + "static/media/login-back-image.51c5bae6.png";